// extracted by mini-css-extract-plugin
export var active = "_f4-2";
export var recordingDot = "_f4-1";
export var recordingIndicator = "_f4-0";